"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBidPrices = void 0;
/**
 * getBidPrices
 * Takes in a value and an increment
 * Returns a standardized value object
 * @param {decimal} price
 * @param {string} format
 * @return object containing the following values:
 * bic: bid in cents (cpm expressed in cents, 1)
 * cpi: cost per impression (0.00001)
 * cpm: cost per 1000 impressions (0.01)
 */
function getBidPrices(price, format) {
    var CPM_TO_CPI_INCREMENT = 1000;
    var CPM_TO_BIC_INCREMENT = 100;
    var cpm, cpi, bic;
    switch (format) {
        case "cpm":
            cpm = price;
            bic = cpm * CPM_TO_BIC_INCREMENT;
            cpi = cpm / CPM_TO_CPI_INCREMENT;
            break;
        case "cpi":
            cpi = price;
            cpm = price * CPM_TO_CPI_INCREMENT;
            bic = cpm * CPM_TO_BIC_INCREMENT;
            break;
        case "bic":
            bic = price;
            cpm = bic / CPM_TO_BIC_INCREMENT;
            cpi = cpm / CPM_TO_CPI_INCREMENT;
            break;
        default:
            cpm = cpi = bic = 0;
            break;
    }
    // this is kind of dirty, but this will round our numbers to the expected maximum number
    // of significant decimal digits, which will remove floating point arithmatic errors.
    // we only do one operation here, so the entropy introduced doesn't seem to be enough
    // to make this fail. If we need to support big increments smaller than a one cent CPM
    // though, this may become problematic.
    return {
        cpm: Number(cpm.toFixed(2)),
        cpi: Number(cpi.toFixed(6)),
        bic: Number(bic.toFixed(0)),
    };
}
exports.getBidPrices = getBidPrices;
